import { Component, computed, inject, input, LOCALE_ID, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { CancelIcon } from '../../../../../../../shared/ui/icons/cancel-icon/cancel-icon';
import { SubmitButton } from '../../../../../../../shared/ui/Buttons/submit-button/submit-button';
import { setItemPackageAction } from '../../../../../../../store/order/confirm-package-order/confirm-package.actions';
import { OrderBundleItem } from '../../order-bundle-item/order-bundle-item';
import { OrderProductItem } from '../../order-product-item/order-product-item';
import { ProductShortageData } from '../../../actions/confirm-package.model';

@Component({
  selector: 'app-confirm-product-popup',
  standalone: true,
  imports: [CommonModule, CancelIcon, SubmitButton, OrderBundleItem, OrderProductItem],
  templateUrl: './confirm-product-popup.html',
})
export class ConfirmProductPopup {
  private locale = inject(LOCALE_ID);
  private store = inject(Store);

  isArabic = computed(() => this.locale.startsWith('ar'));

  data = input.required<ProductShortageData>();
  itemType = input<'product' | 'bundle'>('product');

  closed = output<void>();
  confirmed = output<void>();

  showWarning = signal(false);

  onCancelClick() {
    this.closed.emit();
  }

  onConfirmClick() {
    if (!this.showWarning()) {
      this.showWarning.set(true);
      return;
    }

    const shortage = this.data();

    this.store.dispatch(
      setItemPackageAction({
        itemId: shortage.itemId ?? '',
        itemType: this.itemType(),
        action: 'CONFIRM',
      }),
    );

    this.confirmed.emit();
    this.closed.emit();
  }
}
